import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTE_REGISTRY } from '@/lib/routes'
import { FloatingActionIslandProvider } from '@/contexts/FloatingActionIslandContext'
import { FloatingActionIsland } from '@/components/ui/FloatingActionIsland'
import { INTEGRATIONS } from '@super/shared-types'
import { Heading } from '@/components/ui/typography'
import { BuildingLinkConnectForm } from '@/components/integrations/vendors/BuildingLinkConnectForm'

export function BuildingLinkIntegrationPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const isEditMode = searchParams.get('mode') === 'edit'

  return (
    <div className="h-full pt-16">
      <FloatingActionIslandProvider>
        <div className="space-y-6 p-6 pt-0 pb-24">
          <div className="flex items-center gap-3 mt-6">
            <div className="w-10 h-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <img
                src={INTEGRATIONS.BUILDING_LINK.LOGO_PATH}
                alt={INTEGRATIONS.BUILDING_LINK.NAME}
                className="w-full h-full object-contain"
              />
            </div>
            <Heading variant="subsection-title">
              {isEditMode ? 'Update' : 'Connect'}{' '}
              {INTEGRATIONS.BUILDING_LINK.NAME}
            </Heading>
          </div>

          <BuildingLinkConnectForm
            isEditMode={isEditMode}
            onConnected={() =>
              navigate(ROUTE_REGISTRY.SETTINGS_INTEGRATIONS.path)
            }
          />
        </div>
        <FloatingActionIsland />
      </FloatingActionIslandProvider>
    </div>
  )
}
